import { render, staticRenderFns } from "./DataConversion4Params.vue?vue&type=template&id=e0a0dafc&scoped=true&"
import script from "./DataConversion4Params.vue?vue&type=script&lang=js&"
export * from "./DataConversion4Params.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a0dafc",
  null
  
)

/* custom blocks */
import block0 from "./DataConversion4Params.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports